import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';

import SEO from '../components/seo';

import { Item, Menu } from '../styles/styles.js';

import { menuData } from '../data/menuData.js';

const Bebidas = ({ data }) => {
  return (
    <>
      <SEO
        title="Bebidas"
        keywords={[
          `Coca Cola`,
          `Fanta laranja`,
          `Soda`,
          `Dolly`,
          `Skol`,
          `Itaipava`,
          `Amstel`,
        ]}
      />
      <Menu className="menu">
        <Slide left cascade>
          <h1 className="menu-title">Bebidas</h1>
        </Slide>

        <Fade left>
          <div className="item-image-bebidas">
            <Img
              fluid={data.bebidas.childImageSharp.fluid}
              alt="Bebidas vários sabores"
            />
          </div>
        </Fade>

        {menuData.map((secao, index) => (
          <React.Fragment key={index}>
            <Slide left>
              <h2 className="menu-subtitle">{secao.categoria}</h2>
            </Slide>

            {secao.itens.map((item, itemIndex) => (
              <Item key={itemIndex}>
                <div className="item-separator">
                  <h4 className="item-title">{item.nome}</h4>

                  <div className="item-price-wrapper">
                    <h4 className="item-price">{item.preco}</h4>
                  </div>
                </div>
              </Item>
            ))}
          </React.Fragment>
        ))}
      </Menu>
    </>
  );
};

export const query = graphql`
  query {
    bebidas: file(relativePath: { eq: "bebidas.png" }) {
      childImageSharp {
        fluid(maxWidth: 275, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default Bebidas;
